(function() {
    const suggestSearchBoxEl = document.querySelector('.jsSearchFormWithSuggestions');

    if (suggestSearchBoxEl) {
        const suggestionBox = suggestSearchBoxEl.querySelector('.jsSuggestionBox');
        const input = suggestSearchBoxEl.querySelector('input.input');
        let searchTimeout = null;

        input.addEventListener('keyup', e => {
            if (input.value === '') {
                suggestionBox.classList.remove('visible');
                return;
            }

            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = null;
            searchTimeout = setTimeout(_ => {
                se_postRequest(se_ajax.ajaxurl, { action: 'get_search_suggestions', query: input.value }, response => {
                    if (response) {
                        suggestionBox.innerHTML = response;
                        suggestionBox.classList.add('visible');
                    }
                    else {
                        suggestionBox.classList.remove('visible');
                    }
                }, _ => {
                    console.error('Something went wrong while searching');
                });
            }, 200);
        });

        window.addEventListener('keyup', e => {
            if (e.key.toLowerCase() === 'escape') suggestionBox.classList.remove('visible');
        });

        window.addEventListener('click', _ => {
            suggestionBox.classList.remove('visible');
        });
    }
})();
